// src/components/ModalAgregarFactura.jsx
import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarFactura = ({ show, onClose, pagoId, onFacturaAgregada }) => {
    const [nuevaFactura, setNuevaFactura] = useState({ total: "", detalles: "" });

    // Función para manejar el envío del formulario
    const handleAgregarFactura = async (e) => {
        e.preventDefault();
        if (nuevaFactura.total.trim() === "" || nuevaFactura.detalles.trim() === "") {
            alert("Todos los campos son requeridos.");
            return;
        }

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "facturas",
                pago_id: pagoId,
                total: nuevaFactura.total,
                detalles: nuevaFactura.detalles
            });

            onFacturaAgregada(); // Actualiza la lista de facturas al agregar una nueva
            onClose(); // Cierra el modal
            setNuevaFactura({ total: "", detalles: "" }); // Resetea el formulario
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nueva Factura</h2>
                <form onSubmit={handleAgregarFactura}>
                    <input
                        type="number"
                        value={nuevaFactura.total}
                        onChange={(e) => setNuevaFactura({ ...nuevaFactura, total: e.target.value })}
                        placeholder="Total"
                        className="border rounded-lg p-2 mb-4 w-full"
                        maxLength={10}
                    />
                    <input
                        type="text"
                        value={nuevaFactura.detalles}
                        onChange={(e) => setNuevaFactura({ ...nuevaFactura, detalles: e.target.value })}
                        placeholder="Detalles"
                        className="border rounded-lg p-2 mb-4 w-full"
                        maxLength={50}
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarFactura;
